import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Channel } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useChannel = (
  projectId: string,
  channelId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Channel>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Channel>({
    queryKey: ["projects", projectId, "channels", channelId],
    queryFn: async (): Promise<Channel> => {
      const response = await api.get<Channel>(`/projects/${projectId}/channels/${channelId}`);
      return camelize(response.data);
    },
    ...options
  });
};
